import * as Assets from "Data/Assets";
import { MusicGameSpotlight } from "GameObjects/MusicGame/Spotlight";
import * as HLF from "html-living-framework";
import {ColourRampFilter} from "Filters/ColourRampFilter"

export class MusicGameRampedSpotlight extends MusicGameSpotlight {

    protected startSolo(pData: { character: number; loop: number; bar: number; time: number; }): void {
        this.sprite.visible = true;
        this.sprite.filters = [
            new ColourRampFilter(HLF.PixiUtils.getTexture(Assets.MUS_RAMP + (pData.loop+1).toString()))
        ];
    }
    protected stopSolo(pData: { character: number; }): void {
        this.sprite.visible = false;
        this.sprite.filters = [];
    }
    protected onSoloQueued(pData: { character: number; loop: number; }): void {
        if (!this.sprite.visible) { // don't change colour until solo actually starts, if already visible
            this.sprite.visible = true;
            this.sprite.filters = [
                new ColourRampFilter(HLF.PixiUtils.getTexture(Assets.MUS_RAMP + (pData.loop+1).toString()))
            ];
        }
    }
    protected makeSprite() {
        const newSprite = new PIXI.Sprite(
            HLF.PixiUtils.getTexture(Assets.MUS_LIGHT_ + this._data.name,
                Assets.SPRITESHEET_SPOTLIGHTS)
        );
        newSprite.scale.set(2);
        return newSprite;
    }
}